import {api} from "@/api/api-core";

export const Chat = {
  chat: async (message: string, status: string): Promise<any> => {
    const url = `${process.env.API_GET_CHAT}?message=${encodeURIComponent(message)}&status=${status}`;
    return api.get(url).then((res) => {
      return res.data || [];
    }).catch((err) => {
      console.log(err);
      return [];
    });
  },
  getChatHistory: async (): Promise<any> => {
    const url = `${process.env.API_GET_CHAT_HISTORY}`;
    return api.get(url).then((res) => {
      return res.data || [];
    }).catch((err) => {
      console.log(err);
      return [];
    });
  }

}; 